import styled, { css } from 'styled-components';
import { isMobileOnly } from 'react-device-detect';
import {
  FlexBox,
  DoconModal,
  DoconModalContent,
  DoconModalHeader,
  Heading3,
  Icons,
  PrimaryButton,
} from '@docon/docon-ui-library';
import AppointmentCard from '../components/Card';
import Map from 'shared/Map';
import { bgColor, borderColor, colors } from 'utilities/colorConfig';

const Content = styled(FlexBox)`
  flex-direction: column;
  margin-top: 10px;
  border-radius: 8px;
  background-color: ${colors.white};
  border: 1px solid ${borderColor};
  box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.1);

  ${FlexBox} {
    padding: 1rem;
    order: 1;
    gap: 12px;

    a {
      flex: 1;
      font-size: 18px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      color: ${colors.primaryBlue};
      cursor: pointer;

      svg {
        margin-right: 5px;
      }
    }

    ${Icons.TimerIcon} g {
      stroke-width: 1.5;
      transform: translate(1.3px, 1.3px);
    }
  }

  .address, .footerCard {
    border-top: 1px solid ${borderColor};
  }

  .details {
    order: 0;
    border-bottom: 1px solid ${borderColor};
  }

  ${Map} {
    width: 100px;
    height: 100px;
    flex: none;
  }
`;

const ActionLists = styled(Heading3)`
  display: block;
  margin: 4%;
  color: ${colors.primaryBlue};

  li {
    display: flex;
    gap: 14px;
    align-items: center;
    padding: 3% 2%;
    cursor: pointer;
    border-bottom: 1px solid ${borderColor};
  }
`;

const Footer = styled(FlexBox)`
  gap: 12px;
  margin: 1rem 0;
  margin-bottom: 75px;
  justify-content: center;

  ${PrimaryButton} {
    margin: 0;
    font-size: 16px;
    text-transform: capitalize;

    &.greybtn {
      color: ${colors.black};
      border: none;
      background-color: rgba(23, 23, 77, 0.3);
    }
  }
`;

const Modal = styled(DoconModal)`
  width: 90%;
  max-width: 650px;
  height: 100%;
  max-height: 80%;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
  --closeIconColor: ${colors.white};

  ${DoconModalContent} {
    max-height: initial;
    padding: 1rem 1.5rem;
    background-color: ${bgColor.base};
  }

  ${DoconModalHeader} {
    font-size: 20px;
    line-height: 24px;
    color: ${colors.white};
    background-color: ${colors.primaryBlue};
  }

  ${Icons.DownloadIcon} {
    position: absolute;
    left: 15px;
    top: 15px;
  }

  ${AppointmentCard} {
    padding: 1rem;
  }

  ${() => isMobileOnly && css`
    max-height: 95%;

    ${DoconModalContent} {
      padding: 0.5rem;
    }

    ${Footer} {
      flex-direction: column;

      ${PrimaryButton} {
        width: 100%;
      }
    }
  `}
`;

export {
  Content,
  ActionLists,
  Footer,
  Modal,
};